class ClubcardTokenWithItems {
    /**
     * @param {ClubcardToken} token
     * @param {PlaceholderItem[]} items
     */
    constructor(token, items = []) {
        this.token = token;
        this.items = items;
    }
}

module.exports = ClubcardTokenWithItems;
